import { useCallback, useEffect, useState } from "react";

import { PlusCircleOutlined } from "@ant-design/icons";
import { Form } from "antd";
import { useSelector } from "react-redux";

import { RVButton, RVFormItem, RVCollapse } from "@regal-voice/ui";
import { RVEditableFormItemPanelHeader } from "Components/elements/RVCollapse/Shared/Components/RVEditableFormItemPanelHeader/RVEditableFormItemPanelHeader";
import {
    // selectors
    selectFormFields,
    // actions
    setFields,
} from "Services/state/journeys/JourneyStateSlice";
import { useRVDispatch } from "Services/state/Storage";

import { UpdateContactForm } from "../../constants";
import { extractFormFieldName } from "../../utils";
import { TriggerEventPanelsLayout } from "./Components/TriggerEventPanelsLayout/TriggerEventPanelsLayout";

export function UpdateContactFormPanelEvents(): JSX.Element {
    const [form] = Form.useForm();
    const [showEventPanel, setShowEventPanel] = useState(false);
    const activePanels = Array.from({ length: 99 }, (_, i) => i);
    const dispatch = useRVDispatch();
    const fields = useSelector(selectFormFields);

    useEffect(() => {
        const hasEventName = fields.some((field: any) => field.name === "eventName" || field.name[0] === "eventName");
        if (hasEventName) {
            setShowEventPanel(true);
        } else {
            setShowEventPanel(false);
        }
    }, [fields]);

    const removeEvent = useCallback(() => {
        const filteredFields = fields.filter((field: any) => {
            return extractFormFieldName(field) !== "eventName";
        });
        const furtherFiltered = filteredFields.filter((field: any) => {
            return !extractFormFieldName(field).includes(UpdateContactForm.propertiesListName);
        });
        // We need to dispatch the changes to the store, beause we rerender the form
        // based on the fields in the store
        dispatch(setFields(furtherFiltered));
    }, [dispatch, fields]);

    const customEventPanels = [
        {
            id: "0",
            forceRender: true,
            header: (
                <RVEditableFormItemPanelHeader
                    disabled
                    noIndex
                    panelIndex={0}
                    key="1"
                    form={form}
                    remove={removeEvent}
                    name="Event"
                />
            ),
            content: <TriggerEventPanelsLayout activePanels={activePanels} />,
        },
    ];

    const addEvent = useCallback(() => {
        const newField = {
            name: "eventName",
            value: "",
        };
        dispatch(setFields([...fields, newField]));
    }, [dispatch, fields]);

    return (
        <RVFormItem label="Trigger an Event">
            {!showEventPanel ? (
                <RVButton onClick={addEvent} icon={<PlusCircleOutlined />}>
                    Add Event
                </RVButton>
            ) : (
                <>
                    <RVCollapse panelsList={customEventPanels} activeKey={activePanels}></RVCollapse>
                </>
            )}
        </RVFormItem>
    );
}
